// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmationBanner-cls1_lcE","cls2":"ConfirmationBanner-cls2_nbf ConfirmationBanner-cls1_lcE"};